module.exports = __webpack_public_path__ + "img/doctor-1.827b41a3.png";